import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { UserTokenType } from 'types/global';
import { waitForLeavingDashboard } from '../actions';

const useWaitForLeavingDashboard = () => {
  const dispatch = useDispatch();

  const adminToken = useSelector<any, UserTokenType>(state => state.admin.token);

  useEffect(() => {
    if (!adminToken) {
      dispatch(waitForLeavingDashboard());
    }
  }, [adminToken, dispatch]);
};

export default useWaitForLeavingDashboard;
